import { useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { useBankProfile } from '../contexts/BankProfileContext';
import { useAuth } from './useAuth';
export interface FileProps {
	download: {
		url: string;
		expires_at: string;
	};
	file_size: number;
	filename: string;
	mime_type: string;
	id: string;
}

export type MessageContent = Record<string, string | null | undefined>;

export interface Message {
	uuid: string;
	created_at: string;
	attachments: FileProps[];
	sender_type: 'user' | 'employee';
	read_at: string | null;
	content: MessageContent;
}

interface MessageThreadProps {
	uuid: string;
	topic: {
		name: string;
		value: string;
	};
	messages: Message[];
	customer_id: string;
	is_closed?: boolean;
}

export const useMessageThread = (threadId: string) => {
	const { selectedProfile } = useBankProfile();
	const { session } = useAuth();

	const fetchThread = async (): Promise<MessageThreadProps> => {
		const response = await axios.get(
			`${import.meta.env.VITE_API_HOST}/api/v1/profiles/${selectedProfile.id}/threads/${threadId}`,
			{
				headers: {
					Authorization: session?.tokenized,
				},
			},
		);
		return response.data;
	};

	return useQuery({
		queryKey: ['thread', selectedProfile?.id, threadId, session?.tokenized],
		queryFn: fetchThread,
		enabled: !!selectedProfile && !!session && !!threadId,
	});
};

export function useMarkMessageAsRead() {
	const { selectedProfile } = useBankProfile();
	const { session } = useAuth();

	const markAsRead = async ({
		threadId,
		messageId,
	}: {
		threadId: string;
		messageId: string;
	}) => {
		await axios.patch(
			`${import.meta.env.VITE_API_HOST}/api/v1/profiles/${selectedProfile.id}/threads/${threadId}/messages/${messageId}`,
			null,
			{
				headers: {
					Authorization: session?.tokenized,
				},
			},
		);
	};

	return useMutation({ mutationFn: markAsRead });
}
